import { GivingHistoryItem } from '@sola/schema/dotcom/proxy-api/givingHistory.js';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.js';

export enum GivingTypeEnum {
  Stocks = 'Stocks',
}

export type GivingItemWithCommitment = GivingHistoryItem & {
  commitment?: GraphQLCommitment;
};
